var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 14H14",
    stroke: "#9FA2B4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2V14",
    stroke: "#9FA2B4",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 4,
    fill: "#9FA2B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 2,
    height: 8,
    fill: "#9FA2B4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 2,
    height: 6,
    fill: "#9FA2B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage);
export default __webpack_public_path__ + "static/media/usage.deeec1f012c5de2783ea5f478281b863.svg";
export { ForwardRef as ReactComponent };